export default __webpack_public_path__ + "static/media/loading-24-px-light-blue.c14725de.svg";